import './InfoPanel.scss';
import { t } from '../../i18n/i18n';

/**
 * The card the setup / downloads / help pages are built out of — 1:19786.
 *
 * Extracted once a second and third page needed it: Account Setup, Downloads
 * and Help Centre draw the same object (surface card, ruled heading, optional
 * footnote) and fill it with different rows. Keeping three copies is how the
 * rule under the heading ends up on two of them and not the third.
 *
 * It is deliberately only the shell. What goes inside is each page's own —
 * `InfoRow` and `InfoField` cover the two arrangements all three share, and a
 * page with something else to say (a receipt, a numbered list) simply passes
 * its own children.
 *
 *   title  the heading, left
 *   meta   a note on the right of the heading, e.g. "Not available to US residents"
 *   foot   the line under a hairline at the card's bottom
 */
export default function InfoPanel({ title, meta, foot, className = '', children }) {
  return (
    <section className={`ip-card ${className}`.trim()}>
      <header className="ip-card__head">
        <span className="ip-card__title">{t(title)}</span>
        {meta && <span className="ip-card__meta">{t(meta)}</span>}
      </header>

      {children}

      {foot && <p className="ip-foot">{t(foot)}</p>}
    </section>
  );
}
